import { styled, Slider, Typography, Box, Button } from "@mui/material";

export const StepperSlider = styled(Slider)(({ theme }) => ({
  ".MuiSlider-rail": {
    background: theme.palette.primary.main,
  },
  color: theme.palette.primary.main,
  height: 3,
  paddingTop: theme.spacing(2, 0),
  "& .MuiSlider-thumb": {
    height: 22,
    width: 22,
    backgroundColor: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    "&:hover": {
      boxShadow: "0 0 0 8px rgba(58, 133, 137, 0.16)",
    },
  },
  "& .MuiSlider-track": {
    height: 3,
  },
}));

export const StyledEmail = styled("img")(({ theme }) => ({
  width: "100%",
  height: "100%",
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  fontSize: "40px",
  fontWeight: 500,
}));

export const StyledFooterBox = styled(Box)(({ theme }) => ({
  height: "98px",
  // boxShadow: "0px -10px 25px 0px rgba(0, 0, 0, 0.05) inset",
  width: "100%",
  position: "fixed",
  bottom: 0,
  zIndex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "white",
  left: 0,

  // MuiButton-contained
  // MuiButton-contained
  "& .MuiButtonBase-root": {
    borderRadius: "24px",
    minWidth: "118px",
    marginRight: "30px",
    height: "48px",
    margin: "0 15px",
  },
  "& .MuiButton-contained": {
    borderRadius: "24px",
    minWidth: "118px",
    height: "48px",
    marginRight: "30px",
    color: "white",
    margin: "0 15px",
  },
}));

export const CustomAnimatedText = styled(Typography)(({ theme }) => ({
  transition: "color 0.3s ease",
  fontSize: "48px",
}));

export const StyledViewWebsiteButton = styled(Button)(({ theme }) => ({
  color: "white",
  borderRadius: "52px",
}));

export const CutomImageWraper = styled(Box)(({ theme }) => ({
  width: "105px",
  margin: "0 auto",
  "& img": {
    width: "100%",
  },
}));

export const StyledLogoWrapper = styled(Button)(({ theme }) => ({
  "& img": {
    width: "100%",
  },
}));

export const StyledAddressWrapper = styled(Box)(({ theme, isSelected }) => ({
  padding: theme.spacing(2),
  // width: "457px",
  // boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.20)",
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: 1,
  background: isSelected ? theme.palette.primary.main : "white",
  color: isSelected ? "white" : "black",
  borderRadius: "16px",
  cursor: "pointer",
  transition: "background-color 0.4s ease",
  "&: hover": {
    boxShadow: `0px 0px 3px 1px ${theme.palette.primary.main}`,
    // color: "black",
  },
  [theme.breakpoints.down("lg")]: { width: "90%" },
}));
